import type { GetServerSideProps } from "next";
import { generateBlogSitemap } from "@orlandohealth/build-kit";

export const getServerSideProps: GetServerSideProps = async (context) => {
  return generateBlogSitemap(context);
};

export default function SiteMap() {
  // getServerSideProps will do the heavy lifting
}
